import { useEffect, useState, useRef } from 'react';
import { BraveBupAPI } from '@BUP/services/Axios';
import { useSendMessage, useChangeMessageState } from '@BUP/hooks';
import { message } from 'antd';
import { isModeBupCaseOpen } from '@BUP/services/BraveUp';

export function useChatbox(mainMessage) {
  const chatContainerRef = useRef(null);
  const [handleChangeMessageState] = useChangeMessageState();
  const { handleSendMessage: onSendMessage } = useSendMessage(mainMessage);
  const [listState, setListState] = useState({
    fatherMessage: mainMessage,
    isCaseOpen: isModeBupCaseOpen(mainMessage),
    messages: [],
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    setListState((prevState) => ({
      ...prevState,
      isCaseOpen: isModeBupCaseOpen(prevState.fatherMessage),
    }));
  }, [listState.fatherMessage]);

  const getMessageChildrens = async () => {
    setListState((prevState) => ({
      ...prevState,
      messages: [],
      error: null,
      isLoading: true,
    }));
    try {
      const fatherId = mainMessage?.id;
      const response = await BraveBupAPI.get('/comments', {
        params: {
          parent_comment_id: fatherId,
        },
      });
      const comments = response?.data || [];
      const sortedComments = comments.sort(
        (a, b) => new Date(a?.createdAt) - new Date(b?.createdAt)
      );

      setListState((prevState) => ({
        ...prevState,
        messages: [mainMessage, ...sortedComments],
      }));
    } catch (e) {
      console.log('getMessageChildrens error', e);
      setListState((prevState) => ({
        ...prevState,
        error: e,
      }));
    } finally {
      setListState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };

  useEffect(() => {
    getMessageChildrens();
  }, []);

  const handleSendMessage = async (comment) => {
    try {
      const response = await onSendMessage(comment);
      const data = response?.data;
      if (data) {
        setListState((prevState) => ({
          ...prevState,
          messages: [...prevState.messages, data],
        }));
      }
    } catch (e) {
      message.error({
        content:
          'No fue posible enviar tu mensaje, por favor vuelve a intentarlo.',
        duration: 5,
      });
    }
  };

  const scrollToBottom = () => {
    if (chatContainerRef && chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  const openMainMessage = async (messageId) => {
    try {
      await handleChangeMessageState(messageId, 'OPEN');
      setListState((prevState) => ({
        ...prevState,
        fatherMessage: {
          ...prevState.fatherMessage,
          state: 'OPEN',
        },
      }));
      message.success(`Caso activado y movido a Bandeja de Entrada.`, 8);
    } catch (e) {
      console.log('openMainMessage error', e);
      message.error(
        'Ocurrio un error al activar el caso, vuelve a intentarlo.',
        7
      );
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [listState]);

  return {
    messages: listState.messages,
    isLoading: listState.isLoading,
    error: listState.error,
    handleSendMessage,
    chatContainerRef,
    fatherMessage: listState.fatherMessage,
    isCaseOpen: listState.isCaseOpen,
    openMainMessage,
    getMessageChildrens,
  };
}
